import { ConditionTemplate } from '@/api';

import { isNotEmpty } from './is-empty.util';
import { transformSnakeCaseToTitleCase } from './transform.util';

export const trimConditionName = (conditionName: string) =>
  conditionName.replace('default_question_', '');

export function getConditionTemplateName(
  { condition, displayName }: Partial<ConditionTemplate>,
  isConditionTemplateDisplayNameEnabled: boolean,
) {
  if (isConditionTemplateDisplayNameEnabled && isNotEmpty(displayName)) {
    return displayName;
  }

  const trimmedCondition = condition ? trimConditionName(condition) : undefined;

  return trimmedCondition ? transformSnakeCaseToTitleCase(trimmedCondition) : '';
}
